import { WIRE_CODEC, MAX_PAYLOAD, COMPRESSION_THRESHOLD, createSocketWireParser } from './socketWire.js';
import { CLIENT_PROOF_VERSION } from './socketProof.js';

let initialization;

export async function loadSocketWireRuntime({ fetchRef = globalThis.fetch, onMetric } = {}) {
  const response = await fetchRef('/auth/socket-wire', { credentials: 'include', cache: 'no-store' });
  if (!response.ok) throw new Error(`实时数据协议配置读取失败 (${response.status})`);
  const config = await response.json();
  if (config.codec === 'legacy') return { config, parser: null };
  if (config.codec !== WIRE_CODEC || config.maxPayload !== MAX_PAYLOAD || config.threshold !== COMPRESSION_THRESHOLD || config.roadVersion !== 1 || config.clientProof !== CLIENT_PROOF_VERSION) throw new Error('实时数据协议版本不匹配，请刷新页面');
  if (!initialization) initialization = (async () => {
    const zstd = await import('@bokuweb/zstd-wasm');
    // Vite resolves the library's own new URL('./zstd.wasm', import.meta.url)
    // into this immutable release chunk. Importing it again duplicates ~336KB.
    await zstd.init();
    return zstd;
  })();
  const zstd = await initialization;
  return { config, parser: createSocketWireParser({ compress: zstd.compress, decompress: zstd.decompress, onMetric }) };
}
